import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
type FlowLineProps = {
  steps: string[];
  label?: string;
  className?: string;
};
export function FlowLine({
  steps,
  label,
  className = ''
}: FlowLineProps) {
  return <div className={className} data-id="element-110" data-mp="3sqegg4m80ov">
      {label && <p className="mb-3 text-xs font-bold uppercase tracking-[0.14em] text-brand-deep" data-id="element-111" data-mp="3vxkiceq6ddv6">
          {label}
        </p>}
      <ol className="flex flex-wrap items-center gap-x-2 gap-y-2" aria-label={steps.join(', ')} data-id="element-112" data-mp="387hvqe51503y">
        {steps.map((step, index) => <li key={step} className="flex items-center gap-2" data-id="element-113" data-mp="33b9ix7eb1izy" data-mpi={index}>
            <span className="rounded-md border border-brand-gold/40 bg-brand-goldSoft px-2.5 py-1 text-[11px] font-bold uppercase tracking-[0.08em] text-brand-ink" data-id="element-114" data-mp="3h9ha0yontq37">
              {step}
            </span>
            {index < steps.length - 1 && <ArrowRightIcon size={14} className="shrink-0 text-brand-gold" aria-hidden="true" data-id="element-115" data-mp="rjdz81zmqksu" />}
          </li>)}
      </ol>
    </div>;
}